import { formatDuration } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import React, { useMemo } from 'react';
import { Platform, View } from 'react-native';
import { InsuranceCompanyLogo, Text } from '~/components';

import {
  HiredInsuranceProductType,
  type ContractedService,
} from '~/domain/Assegurou/contractedServices';
import { formatMoney } from '~/utils';

export interface ResumeCardProps {
  data: ContractedService;
}

const ResumeCard: React.FC<ResumeCardProps> = ({ data }) => {
  const monthPrice: number | null = useMemo(() => {
    if (data.productCode === HiredInsuranceProductType.MARISA_AUTO) {
      return data.chosenInstallmentValue ?? null;
    }

    return data.value / data.validity;
  }, [
    data.chosenInstallmentValue,
    data.productCode,
    data.validity,
    data.value,
  ]);

  const duration = useMemo(
    () =>
      data.validity === 12
        ? '1 ano'
        : formatDuration({ months: data.validity }, { locale: ptBR }),
    [data.validity]
  );

  if (!data?.plan) return null;

  const { name, franchiseValue } = data.plan;

  return (
    <View
      className={`rounded-md border border-primary-600 p-4 shadow bg-light-100 ${
        Platform.OS === 'android' ? 'shadow-black/40' : ''
      }`}
    >
      <View className="flex-row items-center justify-between mb-2">
        <Text className="font-medium text-sm text-gray-700 flex-1 mr-2">
          {name}
        </Text>

        <InsuranceCompanyLogo name={data.insuranceCompanyName} />
      </View>

      <View className="flex-row items-center justify-between mb-1">
        <Text className="text-gray-400 text-xs">Valor da Franquia:</Text>
        <Text className="font-medium text-xs text-primary-600">
          {franchiseValue}
        </Text>
      </View>
      <View className="flex-row items-center justify-between">
        <Text className="text-gray-400 text-xs">Duração da apólice:</Text>
        <Text className="font-medium text-xs text-primary-600">{duration}</Text>
      </View>

      {!!monthPrice && (
        <>
          <View className="h-[1px] bg-gray-100 my-2" />
          <Text className="text-right text-[10px] font-medium text-gray-700">
            R$
            <Text className="text-base font-medium">
              {formatMoney(monthPrice)}
            </Text>
            <Text>/mês</Text>
          </Text>
        </>
      )}
    </View>
  );
};

export default ResumeCard;
